(() => {
  'use strict';

  /* ================= UTILITIES ================= */
  const qs = (selector, scope = document) => scope.querySelector(selector);

  /* ================= HEADER SCROLL ================= */
  const initHeaderScroll = () => {
    const header = qs('[data-header]');
    if (!header) return;

    const onScroll = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 50);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  };

  /* ================= SMOOTH SCROLL ================= */
  const initSmoothScroll = () => {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        const targetId = this.getAttribute('href');
        if (targetId === '#') return;

        const targetElement = document.querySelector(targetId);
        if (targetElement) {
          e.preventDefault();
          const headerHeight = parseInt(
            getComputedStyle(document.documentElement)
              .getPropertyValue('--header-height') || '80'
          );
          const targetPosition = targetElement.getBoundingClientRect().top
            + window.pageYOffset
            - headerHeight
            - 20;
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }
      });
    });
  };

  /* ================= BACK TO TOP ================= */
  const initBackToTop = () => {
    const btn = document.getElementById('back-to-top');
    if (!btn) return;

    window.addEventListener('scroll', () => {
      btn.classList.toggle('is-visible', window.scrollY > 400);
    }, { passive: true });

    btn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  };

  /* ================= INIT ================= */
  document.addEventListener('DOMContentLoaded', () => {
    initHeaderScroll();
    initSmoothScroll();
    initBackToTop();
  });
})();
